import { useMemo } from 'react';
import FilterBar from '@components/filters/FilterBar';
import OptionFilterPanel from '@components/filters/OptionFilterPanel';
import ClearancesFilterMenuButton from './ClearancesFilterMenuButton';
import LocationFilterPanel from './LocationFilterPanel';
import {
  FilterState,
  FilterData,
  getFilterLabels,
  clearLocations,
  clearActions,
} from './filterState';

type ClearancesFilterBarProps = {
  filterData: FilterData | null;
  filterState: FilterState;
  onFilterChange: (newState: FilterState) => void;
  onClearAll: () => void;
};

const ClearancesFilterBar: React.FC<ClearancesFilterBarProps> = ({ filterData, filterState, onFilterChange, onClearAll }) => {
  const filterLabels = useMemo(
    () => filterData ? getFilterLabels(filterState, filterData.locations, filterData.actions) : [],
    [filterData, filterState]
  );

  const activeFilters = filterLabels.map(({ key, label, value }) => ({
    key,
    label,
    value,
    onDelete: () => {
      if (key === 'location') {
        onFilterChange(clearLocations(filterState));
      } else {
        onFilterChange(clearActions(filterState));
      }
    },
    popoverContent: key === 'location'
      ? (
        <LocationFilterPanel
          locationFilters={filterData?.locations ?? []}
          filterState={filterState}
          onFilterChange={onFilterChange}
        />
      ) : (
        <OptionFilterPanel
          options={filterData?.actions ?? []}
          selected={filterState.actions}
          onChange={(newActions) => onFilterChange({ ...filterState, actions: newActions })}
        />
      ),
  }));

  return (
    <FilterBar
      filterMenuButton={
        <ClearancesFilterMenuButton
          locationFilters={filterData?.locations ?? []}
          actionFilters={filterData?.actions ?? []}
          filterState={filterState}
          onFilterChange={onFilterChange}
          disabled={filterData === null}
        />
      }
      activeFilters={activeFilters}
      onClearAll={onClearAll}
    />
  );
};

export default ClearancesFilterBar;
